import dayjs from 'dayjs';
import dayjsDuration from 'dayjs/plugin/duration';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(dayjsDuration);
dayjs.extend(localizedFormat);
